import { gql } from "lib/apolloClient";

export const bulkManageAddOnsMutation = gql`
  mutation bulkManageAddOns($input: BulkManageAddOnsInput!) {
    platform {
      bulkManageAddOns(input: $input) {
        isSuccess
        warning
        results {
          addOnType
          isSuccess
          warning
          data
        }
      }
    }
  }
`;
